import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Card from "../../components/Card";
import "./Teams.scss";

import Sharon from "../../assets/images/teamImages/Sharon.jpeg";
import Rejoice from "../../assets/images/teamImages/Rejoice.png";
import rejoice from "../../assets/images/teamImages/rejoice.jpeg";
// Add the other photos here as they come in, then set `image` below:
//import Anaa from "../../assets/images/teamImages/Anna.png";
//import Natasha from "../../assets/images/teamImages/Natasha.png";
//import Priscilla from "../../assets/images/teamImages/Priscilla_Ab.png";

// Members without an `image` automatically get a clean initials avatar.
const team = [
  { name: "Ms. Kerziah Sharon Adjagrah", role: "Executive Director", image: Sharon },
  { name: "Ms. Rejoice Lois Bakye", role: "Director, Communication", image: Rejoice },
  { name: "Mrs. Anna Belinda Baidoo", role: "Director, Administration" },
  { name: "Ms. Beatrice Fobi", role: "Project Coordinator" },
  { name: "Ms. Priscilla Abena", role: "Budget and Finance Coordinator" },
  { name: "Ms. Bernice Fobi", role: "Monitoring and Evaluation Officer" },
  { name: "Ms. Princess Mensah", role: "Disability Project Coordinator" },
  { name: "Mrs. Natasha Osafo-Gyamfi", role: "Counselling Coordinator" },
  { name: "Ms. Rejoice Manuela Adukwei Quaye", role: "Lead, Teen Advisor", image: rejoice },
];

function Team() {
  return (
    <>
      <div className="TeamsCon">
        <div className="overlay"></div>

        <div className="content">
          <Navbar />

          <div className="heroTitle">
            <h1>Our Team</h1>
            <p>The people behind ASK Ghana's work in communities and schools.</p>
          </div>

          <div className="extra"></div>
        </div>
      </div>

      <section className="TeamsIntro">
        <span>MEET THE TEAM</span>
        <h2>Committed to creating positive change</h2>
        <p>
          Driven by passion, empathy and a strong commitment to humanitarian
          values, our team works every day to empower marginalised communities
          across Ghana.
        </p>
      </section>

      <div className="TeamsWrap">
        <div className="teamwraplist">
          {team.map((member) => (
            <Card
              key={member.name}
              backgroundImage={member.image}
              title={member.name}
              description={member.role}
            />
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Team;